import React from 'react';
import { motion } from 'framer-motion';
interface TimelineCardProps {
  number: number;
  title: string;
  description: string;
  details: string;
  isLast?: boolean;
  alignment?: 'left' | 'right';
}
export const TimelineCard = ({
  number,
  title,
  description,
  details,
  isLast = false,
  alignment = 'left'
}: TimelineCardProps) => {
  return <div className="relative mb-16" data-id="element-366">
      <motion.div initial={{
      opacity: 0,
      x: alignment === 'left' ? -50 : 50
    }} whileInView={{
      opacity: 1,
      x: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5
    }} className={`flex items-center gap-8 ${alignment === 'right' ? 'flex-row-reverse' : ''}`} data-id="element-367">
        <div className={`w-1/2 ${alignment === 'right' ? 'text-right' : ''}`} data-id="element-368">
          <motion.div whileHover={{
          scale: 1.02
        }} className="inline-block bg-[#231232]/70 backdrop-blur-md border border-[#6805DA]/20 rounded-xl p-6 shadow-lg transition-all duration-300 hover:border-[#FFC501]/40" data-id="element-369">
            <h3 className="font-outfit text-xl font-bold mb-2 text-white" data-id="element-370">
              {title}
            </h3>
            <p className="text-gray-300 mb-4" data-id="element-371">{description}</p>
            <p className="text-[#FFC501]/80 text-sm" data-id="element-372">{details}</p>
          </motion.div>
        </div>
        <div className="relative" data-id="element-373">
          <motion.div whileHover={{
          scale: 1.1
        }} className="w-16 h-16 rounded-full bg-gradient-to-br from-[#FFC501] to-[#DF4425] flex items-center justify-center shadow-lg shadow-[#FFC501]/20 relative z-10" data-id="element-374">
            <span className="text-[#231232] font-outfit font-bold text-2xl" data-id="element-375">
              {number}
            </span>
          </motion.div>
          {!isLast && <motion.div initial={{
          height: 0
        }} whileInView={{
          height: '100%'
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="absolute top-16 left-1/2 -translate-x-1/2 w-0.5 bg-gradient-to-b from-[#FFC501]/30 to-transparent" data-id="element-376" />}
        </div>
        <div className="w-1/2" data-id="element-377" />
      </motion.div>
    </div>;
};